import { render, staticRenderFns } from "./PostDocCp.vue?vue&type=template&id=2c98765c&scoped=true&"
import script from "./PostDocCp.vue?vue&type=script&lang=js&"
export * from "./PostDocCp.vue?vue&type=script&lang=js&"
import style0 from "./PostDocCp.vue?vue&type=style&index=0&id=2c98765c&prod&lang=css&"
import style1 from "./PostDocCp.vue?vue&type=style&index=1&id=2c98765c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c98765c",
  null
  
)

export default component.exports